import { CenteredLoading, MaintenanceError, twClassMerge } from '@healthhub/react-ui';
import { memo, useContext, useEffect } from 'react';

import { useLayoutViewContext } from '@shared/context';
import { PageTitleContext } from '@shared/context/PageTitleContextWrapper';
import { useGetModulesMaintenanceQuery } from '@shared/services/maintenance';

interface MaintenanceScreenWrapperProps {
  children: React.ReactNode;
  serviceCatalogCode: string;
}

const MaintenanceScreenWrapper = ({ children, serviceCatalogCode }: MaintenanceScreenWrapperProps) => {
  const { setPageTitle } = useContext(PageTitleContext)!;
  const { isMobileView, isSharedServiceView, isStandardView } = useLayoutViewContext();
  const { data, isLoading } = useGetModulesMaintenanceQuery(
    { Code: serviceCatalogCode },
    { skip: !serviceCatalogCode }
  );

  const moduleMaintenance = data?.find((module) => module.Code === serviceCatalogCode && module.IsBlock);
  const isModuleUnderMaintenance = !!moduleMaintenance;

  useEffect(() => {
    if (isModuleUnderMaintenance && moduleMaintenance?.Title) {
      setPageTitle(moduleMaintenance?.Title);
    }
  }, [isModuleUnderMaintenance, moduleMaintenance, setPageTitle]);

  if (isLoading) {
    return (
      <div
        className={twClassMerge(
          'h-full',
          (isMobileView || isStandardView || isSharedServiceView) && 'h-dvh -mt-mobileHeader'
        )}
      >
        <CenteredLoading fullScreen={false} />
      </div>
    );
  }

  if (isModuleUnderMaintenance) {
    return (
      <div className={twClassMerge('h-full', (isMobileView || isStandardView || isSharedServiceView) && 'mt-15 px-8')}>
        <MaintenanceError
          isError={isModuleUnderMaintenance}
          layoutView={{ isMobileView }}
          message={moduleMaintenance?.Message}
          title={moduleMaintenance?.Title}
        />
      </div>
    );
  }

  return children;
};

export default memo(MaintenanceScreenWrapper);
